<div class="d-flex flex-column align-items-center card-page-container">
    <div class="row cards-container">
        <app-card
            *ngFor="let itemCard of cardPage.itemCards"
            [card]="itemCard"
            class="col-12 col-sm-6 col-md-6 col-lg-4 card-spacer"
            (deleteCardEvent)="removeItem($event)"
        >
        </app-card>
    </div>
    <div class="row mt-4 paging-container">
        <div class="col">
            <app-simple-tryb-pagination
                *ngIf="cardPage.numberOfPages>1"
                [collectionSize]="cardPage.numberOfItems"
                [page]="cardPage.pageable.page"
                [pageSize]="cardPage.pageable.pageSize"
                [maxSize]="3"
                (pageChange)="changePage($event)"
            ></app-simple-tryb-pagination>
        </div>
    </div>
</div>
